<template>
    <div id="app">
        <header>
            <div class="page_width">
                <div class="logo">
                    <a style="cursor:pointer;" @click="logoClick">Kinktest</a>
                </div>
                <nav>
                    <button class="mobile_btn" @click="mobileToggle" :class="{icon_delete: mobileNavOpen}"></button>
                    <ul v-show="mobileNavOpen" class="mobile_nav">
                        <template v-if="this.$store.state.user">
                            <li>
                                <router-link to="/frameIndex" :class="{current:routeName=='index'}">Home</router-link>
                            </li>
                            <li>
                                <router-link to="/test_history" :class="{current:routeName=='test_history'}">Test Results</router-link>
                            </li>
                            <li>
                                <router-link to="/myaccount" :class="{current:routeName=='myaccount'}">My Account</router-link>
                            </li>
                        </template>
                        <template v-else>
                            <li>
                                <router-link to="/signin" :class="{current:routeName=='signin'}">Sign In</router-link>
                            </li>
                            <li class="btn_signup">
                                <router-link to="/signup" :class="{current:routeName=='signup'}">Sign Up</router-link>
                            </li>
                        </template>
                    </ul>
                </nav>
            </div>
        </header>
        <router-view></router-view>
        <!--验证码界面-->
        <template v-if="showVerify">
            <div id="verify" class="mainpage" style="overflow: scroll">
                <div class="whitebox" style="overflow: scroll">
                    <h1>Welcome to kinktest.org</h1>
                    <ul>
                        <li class="t_center">Before you proceed to the test results…<br>
                            We need to make sure you’re not a robot.
                        </li>
                    </ul>
                    <verify-image @verified="verified"></verify-image>
                </div><!--whitebox end--->
            </div><!--mainpage end--->
        </template>
        <div class="maintext" v-show="routeName=='index'">
            <div class="page_width">
                <p><strong>Kinktest.org</strong> is a new site in this field. It's operated by real kinksters!</p>
                <p>
                    We believe the secret to having a wonderful sex life is knowing what turns you on. It is a rewarding
                    process! You'll feel empowered to take control of the "Compatibility." That is "doing the right
                    thing with the right person" for the sake of BETTER SEX and BETTER LOVE!
                </p>
                <p>
                    Have you ever asked yourself the question "what are my kinks?" If the answer is YES, you are not alone!
                    Thousands of people want to explore the secrets behind their sexual behaviors.
                    Our site will guide you through the exploration of your sexual archetype, not only by testing your kinks
                    out through a scientifically-designed kink test, but also empowering you with knowledge of
                    <a href="/list-of-kinks-the-definitions-of-most-commonpopular-kinks.html" target="_blank">a list of kinks</a>.
                    Just as we believe: the more you know, the more capable you become to gain control over your sexual satisfaction.
                </p>
                <p>
                    <strong>Kinktest</strong> believes "Kinky is the new sexy".
                </p>
                <p>
                    <router-link class="btn_getstart" to="/starttest">Join us! Take the survey</router-link>
                    - for fun, or for reference! Our well-designed questions
                    will help you discover who you really are on the inside and steer your kinky exploration in the
                    right direction!
                </p>
            </div>
        </div>
        <footer>
            <div class="page_width">
                <div class="col_left f_left">© 2022 Kinktest. All Rights Reserved.</div>
                <div class="col_right f_right"><a href="/blog.html" target="_blank">Blog</a> / <a href="/contactus.html" target="_blank">Contact Us</a> / <a href="/aboutus.html">About Us</a> / <a href="./privacy-policy.html" target="_blank">Privacy Policy</a> / <a href="./advertise.html" target="_blank">Advertisement</a></div>
            </div>
        </footer>

        <!--提示界面-->
        <div id="message" v-if="message">
            <span>{{message}}</span>
        </div>
        <!--ajax加载界面-->
        <div id="pending" v-if="pending">
            <span>
                <!--加载动画-->
                <svg width="2em" height="2em" stroke="currentColor" fill="currentColor" viewBox="0 0 64 64"
                     class="q-spinner text-primary" data-darkreader-inline-fill="" data-darkreader-inline-stroke=""
                     style="--darkreader-inline-fill:currentColor; --darkreader-inline-stroke:currentColor;"><g
                        stroke-width="4" stroke-linecap="round"><line y1="17" y2="29"
                                                                      transform="translate(32,32) rotate(180)"><animate
                        attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(210)"><animate
                        attributeName="stroke-opacity" dur="750ms" values="0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(240)"><animate
                        attributeName="stroke-opacity" dur="750ms" values=".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(270)"><animate
                        attributeName="stroke-opacity" dur="750ms" values=".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(300)"><animate
                        attributeName="stroke-opacity" dur="750ms" values=".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(330)"><animate
                        attributeName="stroke-opacity" dur="750ms" values=".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(0)"><animate
                        attributeName="stroke-opacity" dur="750ms" values=".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(30)"><animate
                        attributeName="stroke-opacity" dur="750ms" values=".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(60)"><animate
                        attributeName="stroke-opacity" dur="750ms" values=".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(90)"><animate
                        attributeName="stroke-opacity" dur="750ms" values=".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(120)"><animate
                        attributeName="stroke-opacity" dur="750ms" values=".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85"
                        repeatCount="indefinite"></animate></line><line y1="17" y2="29"
                                                                        transform="translate(32,32) rotate(150)"><animate
                        attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1"
                        repeatCount="indefinite"></animate></line></g></svg>
            </span>
        </div>
    </div>
</template>

<style>
    #main {
        position: relative;
    }

    #message {
        position: absolute;
        width: 100%;
        top: 280px;
        text-align: center;
    }

    #message span {
        display: inline-block;
        line-height: 50px;
        padding: 0 20px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 5px;
        font-size: 20px;
        color: white;
    }

    #pending {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0);
    }

    #pending span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        background-color: rgba(0, 0, 0, 0.7);
        color: red;
        border-radius: 5px;
    }

    #verify {
        position: fixed;
        padding-top: 81px;
        background-color: rgba(0, 0, 0, 0.5);
    }
</style>
<script>
    import verifyImage from './components/verifyImage2.vue';

    export default {
        data() {
            return {
                mobileNavOpen: false, //when mobile if open the nav, false: close , true: open
            }
        },
        computed: {
            routeName(){
                return this.$route && this.$route.name;
            },
            message() {
                return this.$store.state.message
            },
            pending() {
                return this.$store.state.pending
            },
            showVerify() {
                return this.$store.state.showVerify
            },
            loggedUser(){
                return this.$store.state.user
            }
        },
        components: {verifyImage},
        methods: {
            // verifySuccess(){
            //     this.$store.commit('setVerified',true);
            //     this.$store.commit('changeVerify',false);
            // },
            logoClick(){
                if(this.loggedUser)
                    this.$router.push('/myaccount')
                else
                    window.location.href="/"//跳转到AMP静态首页
            },
            verified() {
                this.$store.commit('setVerified', true);
                this.$store.commit('doVerifyCallback');
                this.$store.commit('changeVerify', false);
            },
            mobileToggle() {
                this.mobileNavOpen = !this.mobileNavOpen;
            }
        },
        mounted() {

        }
    }
</script>
